<template>
  <div class="service" :class="{ active: values.offer === service.id }">
    <a
      :href="service.url"
      target="_blank"
      class="service__info"
      rel="noopener noreferrer"
    >
      <i class="vn-icons vn-icons-question-mark"></i>
    </a>
    <div class="service__wrapper" @click="handleClick(service.id, service.name)">
      <div class="service__head">
        <span class="service__title">{{ service.name }}</span>
      </div>
      <span class="service__subtitle">{{ service.subtitle }}</span>
      <div class="service__excerpt" v-html="service.excerpt"></div>
    </div>
  </div>
</template>

<script>
import { mapWritableState } from 'pinia'
import { useStagesStore } from '../stores/stages'

export default {
  name: 'ServiceItem',
  props: {
    service: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapWritableState(useStagesStore, ['ajaxLoading', 'values']),
  },
  methods: {
    handleClick(id, name) {
      if (this.values.offer === id) {
        this.values.offer = null
        return
      }

      this.values.offer = id
      this.values.offerName = name
    },
  },
}
</script>

<style scoped lang="scss">
.service {
  $this: &;

  display: flex;
  align-items: stretch;
  position: relative;

  &.active {
    #{$this}__wrapper {
      background-color: var(--vn-secondary-color);
      color: #fff;
    }

    #{$this}__info {
      color: #fff;
    }
  }

  &__wrapper {
    padding: 20px;
    background-color: #000;
    color: #fff;
    cursor: pointer;
    transition: 250ms;
    width: 100%;

    &:hover {
      background-color: $gray-900;
    }
  }

  &__head {
    margin-bottom: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 30px;
    min-height: 24px;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    display: block;
    padding-right: 15px;
  }

  &__subtitle {
    font-weight: 700;
    display: block;
    margin: 0 0 30px;
  }

  &__info {
    @include reset-btn;
    width: 24px;
    height: 24px;
    color: #fff;
    font-size: 24px;
    text-decoration: none;
    position: absolute;
    top: 20px;
    right: 20px;
    transition: 250ms;
  }
}
</style>
